import React from 'react'
import ExpandableCard from './ExpandableCard'
import TreeView from './TreeView.jsx'
import PaymentOptions from './PaymentOptions.jsx'
import './NonAbortionServices.scss'
import { NavigateClinicOffering } from '../../shared/constants.js'

const createChildrenLookupTable = (offeringJSON) => {
  const lookupTable = {}

  Object.keys(offeringJSON).forEach((offeringKey) => {
    if (offeringKey === null) return

    const offering = offeringJSON[offeringKey]

    if (offering.parent_key in lookupTable) {
      lookupTable[offering.parent_key].push(offeringKey)
    } else {
      lookupTable[offering.parent_key] = [offeringKey]
    }
  })

  return lookupTable
}

const NonAbortionServices = ({
  allOfferings,
  clinicOfferings,
  lexicon,
  locale,
  acceptsInsurance,
  privateInsurance,
  publicInsurance,
  isFree,
  isFreeStr,
  slidingScale,
  slidingScaleStr,
  acceptsUninsured,
  uninsuredStr,
  financialAssistanceAvailable,
  financialAssistanceAvailableStr,
  paymentOptionsTitle,
  someIns,
  medicaidStr,
  privateAcc,
}) => {
  const childrenLookupTable = createChildrenLookupTable(allOfferings)
  // nonAbortionServicesStrings: [t('clinic_offerings.birth_control'), t('clinic_offerings.emergency_contraception'), t('clinic.show.sti_testing')],

  return (
    <div className="NonAbortionServices">
      {[
        NavigateClinicOffering.BIRTH_CONTROL,
        NavigateClinicOffering.EMERGENCY_CONTRACEPTION,
        NavigateClinicOffering.STI_TESTING,
      ].map((key) => {
        if (!clinicOfferings.includes(key)) return null
        if (!childrenLookupTable)
          return (
            // TODO: eslint (no-undef): nonAbortionServicesStrings & idx, seem to be dead code
            // eslint-disable-next-line no-undef
            <ExpandableCard title={nonAbortionServicesStrings[idx]} key={key} />
          )

        return (
          <ExpandableCard title={lexicon.get(key)} key={key}>
            {childrenLookupTable[key].some((childKey) =>
              clinicOfferings.includes(childKey)
            ) ? (
              <>
                {[
                  NavigateClinicOffering.BIRTH_CONTROL,
                  NavigateClinicOffering.EMERGENCY_CONTRACEPTION,
                  NavigateClinicOffering.STI_TESTING,
                ].includes(key) && <p>{lexicon.get(`subheaders.${key}`)}</p>}
                <TreeView
                  parentKey={key}
                  allOfferings={allOfferings}
                  clinicOfferings={clinicOfferings}
                  childrenLookupTable={childrenLookupTable}
                  locale={locale}
                />
              </>
            ) : (
              <p>
                {lexicon.get('call_for_details', { service: lexicon.get(key) })}
              </p>
            )}
          </ExpandableCard>
        )
      })}
      {acceptsInsurance && (
        <PaymentOptions
          privateInsurance={privateInsurance}
          publicInsurance={publicInsurance}
          isFree={isFree}
          slidingScale={slidingScale}
          acceptsUninsured={acceptsUninsured}
          financialAssistanceAvailable={financialAssistanceAvailable}
          paymentOptionsTitle={paymentOptionsTitle}
          someIns={someIns}
          medicaidStr={medicaidStr}
          privateAcc={privateAcc}
          isFreeStr={isFreeStr}
          slidingScaleStr={slidingScaleStr}
          uninsuredStr={uninsuredStr}
          financialAssistanceAvailableStr={financialAssistanceAvailableStr}
        />
      )}
    </div>
  )
}

export default NonAbortionServices
